import { ExtranetInviteTokenDto } from '@pharmac-extranet/extranet-api'
import { CheckIcon, ExtranetContainer, useLanguage } from '@pharmac-extranet/shared'
import { PharmacButton, PharmacIcon, PharmacText } from '@pharmac/ui'
import { useState } from 'react'
import { ConfirmationModal } from '../confirmation-modal/ConfirmationModal'
import { addClock } from './InviteLinkItem'

type Props = {
  token: ExtranetInviteTokenDto
  deleteInviteToken: () => void
}

export const InviteLinkMobileDetails = ({ token, deleteInviteToken }: Props) => {
  const [deleteModal, setDeleteModal] = useState<boolean>(false)
  const { t } = useLanguage(['extranet'])

  return (
    <ExtranetContainer
      full
      style={{ borderTop: '2px dashed var(--color-accent-4)' }}
    >
      <ExtranetContainer
        flexColumn
        full
        paddingMediumHorizontal
        paddingMediumVertical
      >
        <PharmacText
          weight="bold"
          paddingSmallBottom
        >
          {t('inviteLinks.inviteCreator')}
        </PharmacText>
        <PharmacText paddingLargeBottom>
          {token.user.firstName} {token.user.lastName}
        </PharmacText>
        <PharmacText
          weight="bold"
          paddingSmallBottom
        >
          {t('inviteLinks.InvitationLinkRecipientEmail')}:
        </PharmacText>
        <PharmacText paddingLargeBottom>{token.userEmail}</PharmacText>
        <PharmacText
          weight="bold"
          paddingSmallBottom
        >
          {t('inviteLinks.expires')}:
        </PharmacText>
        <PharmacText paddingLargeBottom>
          {addClock(token.validTo, t('clock', { ns: 'common' }))}
        </PharmacText>
        <ExtranetContainer
          flexRow
          alignCenter
          paddingLargeBottom
        >
          <PharmacText
            weight="bold"
            paddingSmallRight
          >
            {t('inviteLinks.usable')}:
          </PharmacText>
          <CheckIcon icon="checkCircle" />
        </ExtranetContainer>
        <ExtranetContainer
          flexColumn
          paddingLargeBottom
        >
          <PharmacText
            weight="bold"
            paddingSmallBottom
          >
            {t('user.userRoles')}:
          </PharmacText>
          {token.roles.map((role) => (
            <PharmacText
              paddingSmallRight
              paddingSmallBottom
              key={role.id}
            >
              {t(`customer.roles.${role.role}`)}
            </PharmacText>
          ))}
        </ExtranetContainer>
        <ExtranetContainer
          full
          flexRow
          justifyCenter
        >
          <PharmacButton
            fullWidth
            variant="secondary"
            onClick={() => setDeleteModal(true)}
          >
            <PharmacText
              paddingSmallRight
              weight="bold"
            >
              {t('inviteLinks.cancelInviteLink')}
            </PharmacText>

            <PharmacIcon icon="trash2" />
          </PharmacButton>
        </ExtranetContainer>
      </ExtranetContainer>
      <ConfirmationModal
        title={t('inviteLinks.cancelInviteLinkModal')}
        content={
          <ExtranetContainer
            full
            flexColumn
          >
            <PharmacText>{t('inviteLinks.cancelInviteLinkDescription')}</PharmacText>
            <PharmacText weight="semibold">{token.userEmail}</PharmacText>
          </ExtranetContainer>
        }
        onSubmit={() => deleteInviteToken()}
        onClose={() => setDeleteModal(false)}
        showOnProp={deleteModal}
      />
    </ExtranetContainer>
  )
}
